import {Box, Button, Typography} from "@mui/material"
import {Trans, useTranslation} from "react-i18next"
import {Panel} from "@indebted/components/Panel"
import {CancelledIcon} from "@indebted/assets"
import {NewLayoutPage} from "@indebted/components/Page"
import {colors} from "@indebted/theme/colors"
import {IndebtedLogoWithYear} from "@indebted/components/IndebtedLogoWithYear"

import {usePaymentArrangementInitiateSetup} from "../usePaymentArrangementInitiateSetup"

import {PaymentArrangementCancelledDetails} from "./CancelledByAgent"

import {useStatusPageData} from "./index"

export function CancelledByCustomerPage() {
	const data = useStatusPageData()
	const {ClientName, CustomerName} = data.data
	const {t} = useTranslation()

	const initiateSetupMutation = usePaymentArrangementInitiateSetup()

	return (
		<NewLayoutPage>
			<Box
				sx={{
					padding: "1.5rem",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					alignSelf: "stretch",
					borderRadius: "0.5rem",
					border: "1px solid #B42318",
					background: "#FEF3F2",
					boxShadow: "0 8px 24px 0 rgba(170, 170, 170, 0.12)",
					marginBottom: "2rem",
				}}
			>
				<CancelledIcon style={{paddingBottom: "1rem"}} />

				<Typography
					sx={{
						color: colors.error["700"],
						textAlign: "center",
						fontSize: "1.5rem",
						fontWeight: "700",
						lineHeight: "2rem",
						paddingBottom: "0.5rem",
					}}
				>
					{t("payment_arrangement_status.cancelled.title")}
				</Typography>
				<Typography
					variant="h1"
					sx={{
						color: "secondary",
						textAlign: "center",
						fontSize: "0.875rem",
						fontWeight: "400",
						lineHeight: "1.25rem",
					}}
				>
					{t("payment_arrangement_status.cancelled.customer_cancelled.reason")}
				</Typography>
			</Box>
			{/* Greeting */}
			<Typography
				textAlign="start"
				variant="body1"
				sx={{
					color: "secondary",
					fontSize: "0.875rem",
					fontWeight: "700",
					lineHeight: "1.25rem",
					paddingBottom: "1rem",
				}}
			>
				{t("payment_arrangement_status.cancelled.greeting", {
					CustomerName,
				})}
			</Typography>
			<Typography
				textAlign="start"
				variant="body1"
				sx={{
					color: "secondary",
					fontSize: "0.875rem",
					fontWeight: "400",
					lineHeight: "1.25rem",
					paddingBottom: "1rem",
				}}
			>
				{t("payment_arrangement_status.cancelled.customer_cancelled.message", {
					ClientName,
				})}
			</Typography>

			<Panel>
				<Typography
					variant="h2"
					sx={{
						color: "secondary",
						fontSize: "1rem",
						fontWeight: "700",
						lineHeight: "1.5rem",
						paddingBottom: "0.5rem",
					}}
				>
					{t("payment_arrangement_status.cancelled.setup_new.title")}
				</Typography>
				<Typography
					variant="body1"
					sx={{
						color: "secondary",
						fontSize: "0.875rem",
						fontWeight: "400",
						lineHeight: "1.25rem",
						paddingBottom: "1rem",
					}}
				>
					{t("payment_arrangement_status.cancelled.setup_new.message")}
				</Typography>
				<Button
					variant="contained"
					color="primary"
					onClick={() => initiateSetupMutation.mutate()}
					sx={{marginBottom: "0.5rem", width: "100%"}}
				>
					{t("payment_arrangement_status.cancelled.setup_new.button_label")}
				</Button>
			</Panel>
			{/* Payment Details Card */}
			<Box sx={{paddingTop: "1rem", marginBottom: "1rem"}}>
				<PaymentArrangementCancelledDetails />
			</Box>
			<IndebtedLogoWithYear />
		</NewLayoutPage>
	)
}
